module.exports = "<section class=\"row no-margin h-100\">\n  <iframe class=\"iframe\" [src]=\"safeUrl\" frameborder=\"0\" allowfullscreen></iframe>\n</section>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/descuentos/descuentos.component.html
// module id = ../../../../../src/app/pages/admin/descuentos/descuentos.component.html
// module chunks = main